<template>
  <div class="man_layout">
    <!-- 头部通栏 (Full-width Header) -->
    <div class="header_container">
      <heade />
    </div>
    
    <!-- 下部主体 (Sidebar + Content Side-by-Side) -->
    <div class="body_container">
      <!-- 左侧边栏 -->
      <div class="man_l">
        <SideBar ref="sideBar" @childer="childerClick($event)" />
      </div>
      
      <!-- 右侧内容区 -->
      <div class="content">
        <div class="content_man">
          <div>
            <routing v-if="state.isCollapse" />
          </div>
          <div class="view_box">
            <transition name="fade" mode="out-in">
              <router-view />
            </transition>
          </div>
        </div>
        <div class="content_footer">
          Copyright © 江苏金航科技有限公司 
          <span>苏ICP备2023020389号-2</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import SideBar from "./components/sideBar.vue";
import routing from "./components/routing.vue";
import heade from "./components/heade.vue";
import { onMounted, ref, reactive, nextTick, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
const routers = useRouter();
const router = useRoute();
import { useStore } from "@/stores/modules/router.js";
const userData = useStore();
const { getRouter, getShow, getClearData, onUnmounted } = userData;

const state = reactive({
  boxWidth: 0,
  navBoxWidth: 0,
  boxOffsetHeight: 0,
  element: 0,
  isCollapse: false,
  isTran: false,
});

watch(
  () => router.path,
  (newPath) => {
    try {
      routers.options.routes[0].children.map((v, index) => {
        if (newPath == v.path) {
          if (!v.children) {
            state.isCollapse = false;
          } else {
            state.isCollapse = true;
            childerClick(v);
          }
        }
        if (v.children) {
          v.children.map((j) => {
            if (j.path.includes(router.path)) {
              state.isCollapse = true;
              childerClick(v);
            }
          });
        }
      });
    } catch { }
  },
  { immediate: false }
);

const sideBar = ref();
onMounted(() => {
  if (router.path == "/home") {
    return;
  }
  nextTick(() => {
    if (sideBar.value) {
      state.isCollapse = userData.isShow;
    }
  });
});

const childerClick = (item) => {
  userData.num = 0;
  item.children ? (state.isCollapse = true) : (state.isCollapse = false);
  getRouter(item);
  getShow(state.isCollapse);
};
</script>

<style lang="less" scoped>
.man_layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background-color: #0b0f16;
}

.header_container {
  height: 60px;
  width: 100%;
  flex-shrink: 0;
}

.body_container {
  display: flex;
  flex: 1;
  height: calc(100vh - 60px);
  width: 100%;
  overflow: hidden;
}

.man_l {
  width: 180px;
  height: 100%;
  flex-shrink: 0;
  background-color: #0b0f16;
  border-right: 1px solid rgba(0, 212, 255, 0.1);
}

.content {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #f4f5fa;
  height: 100%;
  overflow: hidden;
}

.content_man {
  flex: 1;
  display: flex;
  overflow: hidden;
  height: calc(100% - 40px);
}

.view_box {
  flex: 1;
  overflow: auto;
  padding: 0;
}

.content_footer {
  text-align: center;
  padding: 10px;
  font-size: 12px;
  color: #888;
  background-color: #f4f5fa;
  flex-shrink: 0;
  span {
    margin-left: 10px;
    color: #888;
  }
}

/* 渐变设置 */
.fade-enter-from,
.fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
  opacity: 1;
}

.fade-enter-active {
  transition: all 0.7s ease;
}

.fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.6, 0.6, 1);
}
</style>
